import React, { useState, useCallback, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import querystring from 'querystring';
import moment from 'moment';
import { translator } from '../../utils/Translator';

import ReactTable from "../ReactTable/TableVisitRouteSticky3";
// import { numberFormat } from '../../../../utils/NumberFormat';
const DailyStock = ({ customerCode, stockFilter, noOfStockSuggestion }) => {
    const { authUser } = useSelector(({ auth }) => auth);
    const { languageSelected } = useSelector(({ settings }) => settings);
    const { langCustomerFocus } = useSelector(({ i18nCustomerFocus }) => i18nCustomerFocus);
    const { displaySalesHistorySelected, amountSalesHistorySelected, itemGroupSalesHistorySelected
            , productGroupSalesHistorySelected, productLineSalesHistorySelected, productTypeSalesHistorySelected
        } = useSelector(({ customerFocus }) => customerFocus)
    const { productProductGroupFocus, productProductLineFocus, productProductTypeFocus
    } = useSelector(({ product }) => product)
    const { translate } = useSelector(({ i18n }) => i18n);

    const [stockDateLoading, setStockDateLoading] = useState(true);
    const [stockDateData, setStockDateData] = useState([]);

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [dataTotal, setDataTotal] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const fetchIdRef = useRef(0);

    const [exportLoading, setExportLoading] = useState(false);
    const [exportData, setExportData] = useState([]);

    let dateData = [];

    useEffect(() => {
        const fetchStockDate = async () => {
            setStockDateLoading(true);
            setStockDateData([]);
            dateData = [];

            const params = {
                company: authUser.company !== "#" ? authUser.company : "",
                customerCode: customerCode,
                // company: "46",
                // customerCode: "KCLMC00100",
                language: languageSelected.id,
            }

            let queryString = querystring.stringify(params);
            const url = `${process.env.REACT_APP_API_URL}stockCard/dailyDate?${queryString}`;

            try {
                const result = await axios(url, { headers: { "Authorization": `Bearer ${localStorage.getItem('x-access-token')}` } });
                const resultData = result.data;

                if (resultData) {
                    setStockDateData(resultData.map(data => {
                        return {
                            value: data.CntrIdx,
                            label: data.DocRefDate,
                            remark: data.Remarks
                        }
                    }))
                }

            } catch (error) {
                console.log(error);
            }

            setStockDateLoading(false);
        }

        fetchStockDate();

    }, [authUser, languageSelected, customerCode])

    const fetchData = useCallback(async ({ sortBy, pageSize, pageIndex }) => {
        // Give this fetch an ID
        const fetchId = ++fetchIdRef.current

        // Set the loading state
        setLoading(true);
        setData([]);

        setExportLoading(true);
        setExportData([]);

        let itemgroup = "";
        // if(itemGroupSalesHistorySelected && itemGroupSalesHistorySelected !== null){
        //     itemgroup = itemGroupSalesHistorySelected.value;
        // }
        if (itemGroupSalesHistorySelected && itemGroupSalesHistorySelected.length > 0) {
            itemgroup = itemGroupSalesHistorySelected.map(q => q.value).join(',');
        }

        let productgroup = "";
        // if(productGroupSalesHistorySelected && productGroupSalesHistorySelected !== null){
        //     productgroup = productGroupSalesHistorySelected.value;
        // }
        if (productGroupSalesHistorySelected && productGroupSalesHistorySelected.length > 0) {
            productgroup = productGroupSalesHistorySelected.map(q => q.value).join(',');
        }

        let productline = "";
        // if(productLineSalesHistorySelected && productLineSalesHistorySelected !== null){
        //     productline = productLineSalesHistorySelected.value;
        // }
        if (productLineSalesHistorySelected && productLineSalesHistorySelected.length > 0) {
            productline = productLineSalesHistorySelected.map(q => q.value).join(',');
        }

        let producttype = "";
        if (productTypeSalesHistorySelected && productTypeSalesHistorySelected.length > 0) {
            producttype = productTypeSalesHistorySelected.map(q => q.value).join(',');
        }

        let strFocusGroup = "";
        if (productProductGroupFocus && productProductGroupFocus == true){
            strFocusGroup = "F";
        }else{
            strFocusGroup = "";
        }

        let strFocusLine = "";
        if (productProductLineFocus && productProductLineFocus == true){
            strFocusLine = "F";
        }else{
            strFocusLine = "";
        }

        let strFocusType = "";
        if (productProductTypeFocus && productProductTypeFocus == true){
            strFocusType = "F";
        }else{
            strFocusType = "";
        }

        if (fetchId === fetchIdRef.current) {
            const pageNumber = pageIndex + 1
            const endRow = pageNumber * pageSize

            const params = {
                company: authUser.company !== "#" ? authUser.company : "",
                customerCode: customerCode,
                // company: "46",
                // customerCode: "KCLMC00100",
                language: languageSelected.id,
                display: displaySalesHistorySelected.value,
                itemgroup: itemgroup,
                productgroup: productgroup,
                productline: productline,
                producttype: producttype,
                focusGroup: strFocusGroup ? strFocusGroup : "",
                focusLine: strFocusLine ? strFocusLine : "",
                focusType: strFocusType ? strFocusType : "",
                sortBy: sortBy.length > 0 ? sortBy[0].id : "",
                sort: sortBy.length > 0 ? sortBy[0].desc ? "desc" : "asc" : "",
                page: pageIndex + 1,
                perPage: pageSize,
            }
            let queryString = querystring.stringify(params);
            const url = `${process.env.REACT_APP_API_URL}stockCard/daily?${queryString}`;

            try {
                const result = await axios(url, { headers: { "Authorization": `Bearer ${localStorage.getItem('x-access-token')}` } });
                const resultData = result.data.data;
                const resultTotal = result.data.total;


                setData(resultData);
                setExportData(resultData);
                setDataTotal(resultTotal);
                setPageCount(Math.ceil(resultTotal / pageSize));

            } catch (error) {
                console.log(error);
            }
        }

        setLoading(false);
        setExportLoading(false);

    }, [authUser, languageSelected, customerCode, displaySalesHistorySelected, itemGroupSalesHistorySelected, productGroupSalesHistorySelected, productLineSalesHistorySelected, productTypeSalesHistorySelected, productProductGroupFocus, productProductLineFocus, productProductTypeFocus]);

    let setColumn = [];
    setColumn.push({
        Header: '',
        id: 'Description',
        sticky: "left",
        columns: [
            {
                Header: () => <div className="text-center font-weight-bold">{displaySalesHistorySelected.label}</div>,
                accessor: 'Description',
                Cell: cellInfo => <div>{cellInfo.row.original.Description} {cellInfo.row.original.Code ? "(" + cellInfo.row.original.Code + ")" : ""} </div>,
                width: 300
            },
        ],
    });

    let headers = [];
    headers.push({
        label: displaySalesHistorySelected.label,
        key: "Description",
    })

    stockDateData && stockDateData.forEach(dateData => {
        const id = ("0" + dateData.value).slice(-2);

        setColumn.push({
            Header: () =>
                <div className="text-center font-weight-bold">
                    {moment(dateData.label).format('DD/MM/YYYY')}
                    <div>{dateData.remark}</div>
                </div>,
            id: id,
            columns: [
                {
                    Header: () => <div className="text-center font-weight-bold">{translator(translate.ISA_Stock, "สินค้าคงเหลือ")}</div>,
                    accessor: `StkQty_${id}`,
                    Cell: row => <div className="text-right">{row.value || 0}</div>,
                    width: 100,
                },
                {
                    Header: () => <div className="text-center font-weight-bold">{translator(translate.ISA_Order, "Order")}</div>,
                    accessor: `SOQty_${id}`,
                    Cell: row => <div className="text-right">{row.value || 0}</div>,
                    width: 100
                },
            ],
        })

        headers.push({
            label: `Stock (${moment(dateData.label).format('DD/MM/YYYY')})`,
            key: `StkQty_${id}`
        })

        headers.push({
            label: `Order (${moment(dateData.label).format('DD/MM/YYYY')})`,
            key: `SOQty_${id}`
        })
    })

    setColumn.push({
        Header: '',
        id: `Stock`,
        sticky: "left",
        columns: [
            {
                Header: () => <div className="text-center font-weight-bold">{translator(translate.ISA_Customer_Info, "ข้อมูลลูกค้า")}</div>,
                accessor: `Stock`,
                Cell: row => <div className="text-right">{row.value || 0}</div>,
                width: 100
            },
        ],
    });

    setColumn.push({
        Header: '',
        id: `SuggestStock`,
        sticky: "left",
        columns: [
            {
                Header: () => <div className="text-center font-weight-bold">{translator(translate.ISA_Recommend, "แนะนำ")}</div>,
                accessor: `SuggestStock`,
                Cell: row => <div className="text-right">{row.value || 0}</div>,
                width: 100
            },
        ],
    });

    // if (noOfStockSuggestion) {
    //     if (noOfStockSuggestion > 1) {
    //         for (let i = 0; i < noOfStockSuggestion; i++) {
    //             setColumn.push({
    //                 Header: '',
    //                 id: `SuggestStock${i + 1}`,
    //                 columns: [
    //                     {
    //                         Header: () => <div className="text-center font-weight-bold">แนะนำ {i + 1}</div>,
    //                         accessor: `SuggestStock${i + 1}`,
    //                         Cell: row => <div className="text-right">{numberFormat(row.value, 3)}</div>,
    //                         width: 100
    //                     },
    //                 ],
    //             });

    //             headers.push({
    //                 label: `แนะนำ ${i + 1}`,
    //                 key: `SuggestStock${i + 1}`
    //             })
    //         }
    //     } else {
    //         setColumn.push({
    //             Header: '',
    //             id: `SuggestStock1`,
    //             columns: [
    //                 {
    //                     Header: () => <div className="text-center font-weight-bold">แนะนำ</div>,
    //                     accessor: `SuggestStock1`,
    //                     Cell: row => <div className="text-right">{numberFormat(row.value, 3)}</div>,
    //                     width: 100
    //                 },
    //             ],
    //         });

    //         headers.push({
    //             label: `แนะนำ`,
    //             key: `SuggestStock1`
    //         })
    //     }

    // }

    const columns = React.useMemo(() => setColumn, [setColumn, stockDateData, displaySalesHistorySelected]);

    return (
        <div style={stockFilter === 'daily' ? { display: 'block' } : { display: 'none' }} >
            {(exportLoading === false && loading === false) &&
                <CSVLink
                    data={exportData}
                    headers={headers}
                    filename={`${translator(translate.ISA_DailyStock, "ยอดระบาย (รายครั้ง)")}.csv`}
                    className="jr-btn jr-btn-lg bg-green text-white mb-4 text-center float-right"
                    style={{ width: 180 }}
                >
                    <i className="zmdi zmdi-grid" />
                    <span>{translator(translate.ISA_ExportDataEN, "Export ข้อมูล")}</span>
                </CSVLink>
            }

            <ReactTable
                columns={columns}
                data={data}
                dataTotal={dataTotal}
                fetchData={fetchData}
                loading={loading}
                initialSortBy={[{ id: `StkQty_01`, desc: true }]}
                pageCount={data.length}
            />
        </div>
    )
};

export default DailyStock;